"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationState = exports.verificationStates = void 0;
exports.verificationStates = {
    /**
     * Verification is pending
     */
    VERIFICATION_PENDING: 'verificationPending',
    /**
     * Verified successfully
     */
    VERIFICATION_VERIFIED: 'verificationVerified',
    /**
     * Verification rejected
     */
    VERIFICATION_REJECTED: 'verificationRejected',
};
var VerificationState;
(function (VerificationState) {
    VerificationState["VERIFICATION_PENDING"] = "verificationPending";
    VerificationState["VERIFICATION_VERIFIED"] = "verificationVerified";
    VerificationState["VERIFICATION_REJECTED"] = "verificationRejected";
})(VerificationState || (exports.VerificationState = VerificationState = {}));
